import React from 'react'

export const About = () => {
    return (
        <>
        <div>
        <h4>This is an about component</h4>
            <p>This is an web application developed using Reactjs.
                Using this app, user can add a todo in the list and
                user can also delete the Todo already present in the list.</p>
        </div>
        </>
    )
}
